import { useMemo } from "react";
import {
  TextField,
  DatagridConfigurable,
  DateField,
  NumberField,
  useTheme,
  FunctionField,
} from "react-admin";
import FactoryDebtCorrectionExpandList from "../../components/factoryDebtCorrections/expand/FactoryDebtCorrectionExpandList";
import factoryDebtCorrectionFilterList from "../../components/factoryDebtCorrections/filter/factoryDebtCorrectionFilterList";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import AccountPayableCorrectionFooterList from "../../components/accountPayableCorrections/footer/AccountPayableCorrectionFooterList";
import MyDatagridBody from "../../components/common/MyDatagridBody";
import AccountPayableCorrectionExpandList from "../../components/accountPayableCorrections/expand/AccountPayableCorrectionExpandList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";
import ManualReportList from "../../components/reports/ManualReportList";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const AccountPayableCorrectionList = () => {
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters({
      start_date: firstDate,
      end_date: lastDate,
      approved: 1,
    });
  const [theme] = useTheme("light");

  const list = useMemo(
    () => (
      <ManualReportList
        title="mine.list_title.factory_debt_correction"
        empty={false}
        actions={<DownloadAction />}
        filters={factoryDebtCorrectionFilterList(permissions)}
        queryOptions={{ meta: { sort: ["code ASC"] } }} // overide default sort
        filterDefaultValues={filterDefaultValues}
        requiredFilters={["start_date", "end_date"]}
      >
        <DatagridConfigurable
          body={
            <MyDatagridBody footer={<AccountPayableCorrectionFooterList />} />
          }
          bulkActionButtons={false}
          expand={<AccountPayableCorrectionExpandList />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField label="mine.label.depo" source="company.alias" />
          ) : null}
          <TextField source="code" label="mine.label.receipt_no" />
          <DateField
            source="date"
            label="mine.label.date"
            options={{
              year: "numeric",
              month: "short",
              day: "2-digit",
            }}
          />
          <TextField label="Supplier" source="supplier.name" />
          <FunctionField
            label="Lawan GL"
            render={(record) => {
              for (
                let i = 0;
                i < record.factory_debt_correction_journals.length;
                i++
              ) {
                const elm = record.factory_debt_correction_journals[i];
                if (elm.chart_of_account.code !== "2102") {
                  return (
                    elm.chart_of_account.code +
                    " - " +
                    elm.chart_of_account.name
                  );
                }
              }
              return "";
            }}
          />
          <NumberField source="total" />
          <TextField source="note" label="mine.label.note" />
        </DatagridConfigurable>
      </ManualReportList>
    ),
    [theme, permissions, canSeeCompanyColumn, filterDefaultValues]
  );
  return list;
};

export default AccountPayableCorrectionList;
